// React Dependencies
import React from 'react';

// External Dependencies
import { Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';

// Internal Dependencies
import PoisPopularTagTable from './table';
import MText from '../../common/MText';
import Colours from '../../../styles/colours';

const PoisPopularTagList = () => (
  <div>
    <div className="justify-content-start content-header">
      <Link to="/admin/pois" className="d-flex align-items-center">
        <Icon className="back">arrow_back</Icon>
      </Link>
      <MText variant="h1" text="Popular Tags" bold colour={Colours.Gray6} />
    </div>

    <PoisPopularTagTable />
  </div>
);

export default PoisPopularTagList;
